exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-range__slider{\n    background: #4ab5d2;\n    border: none;\n}\n.input-range__track--active{\n    background: #4ab5d2;\n}", ""]);

// exports
